interface AboutSectionProps {
  onCategoryClick: () => void;
}

export default function AboutSection({ onCategoryClick }: AboutSectionProps) {
  const features = [
    {
      title: 'Gestione dati semplice',
      desc: 'Organizza informazioni rapidamente con strumenti intuitivi e interfacce chiare.',
      image: 'https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20with%20color%20coded%20folders%20and%20minimal%20stationery%2C%20soft%20morning%20light%20from%20side%20window%2C%20warm%20cream%20and%20sage%20tones%2C%20European%20home%20office%20aesthetic%2C%20editorial%20photography%2C%20calm%20productive%20atmosphere%2C%20gentle%20shadows&width=600&height=400&seq=about-01-v2&orientation=landscape',
    },
    {
      title: 'Maggiore produttività',
      desc: 'Riduci le attività manuali e migliora il flusso di lavoro quotidiano.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20dual%20monitor%20setup%20showing%20organized%20dashboard%2C%20potted%20plant%20on%20desk%2C%20warm%20afternoon%20lighting%2C%20sand%20and%20ivory%20tones%2C%20Scandinavian%20office%20interior%2C%20editorial%20productivity%20photography%2C%20clean%20aesthetic&width=600&height=400&seq=about-02-v2&orientation=landscape',
    },
    {
      title: 'Analisi avanzata',
      desc: 'Utilizza strumenti di gestione dati più efficienti per risultati migliori.',
      image: 'https://readdy.ai/api/search-image?query=Data%20visualization%20concept%20with%20abstract%20charts%20and%20graphs%20on%20light%20background%2C%20soft%20modern%20aesthetic%2C%20warm%20neutral%20tones%2C%20clean%20infographic%20style%2C%20European%20design%20studio%20photography%2C%20minimal%20tech%20atmosphere&width=600&height=400&seq=about-03-v2&orientation=landscape',
    },
    {
      title: 'Collaborazione intelligente',
      desc: 'Lavora sui tuoi dati in modo più organizzato e produttivo.',
      image: 'https://readdy.ai/api/search-image?query=Team%20collaboration%20workspace%20with%20two%20laptops%20and%20shared%20documents%20on%20light%20oak%20table%2C%20natural%20window%20light%2C%20warm%20beige%20and%20cream%20tones%2C%20European%20co%20working%20interior%2C%20editorial%20photography%2C%20productive%20team%20atmosphere%2C%20soft%20shadows&width=600&height=400&seq=about-04-v2&orientation=landscape',
    },
  ];

  return (
    <section className="w-full bg-accent-100/60 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <span className="inline-block px-5 py-2 bg-background-50 rounded-full text-xs font-medium text-foreground-700 font-label tracking-wide">
          Informazioni
        </span>

        <h2 className="mt-8 text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 font-heading leading-tight max-w-3xl">
          Cos&apos;è{' '}
          <span className="italic font-normal">Itaobuy Spreadsheet</span>?
        </h2>

        <p className="mt-6 text-base md:text-lg text-foreground-700 max-w-2xl font-body leading-relaxed">
          Itaobuy Spreadsheet è una soluzione moderna per organizzare, analizzare e gestire informazioni attraverso fogli di calcolo intelligenti. Questa guida nasce per aiutare gli utenti italiani a comprendere meglio caratteristiche, vantaggi e modalità di utilizzo di itaobuy sheet.
        </p>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((item) => (
            <div key={item.title} className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/40 hover:border-accent-300/60 transition-all duration-300">
              <div className="h-40 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="text-sm font-semibold text-foreground-900 font-label">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 font-body leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-2 sm:grid-cols-4 gap-6">
          {[
            { value: '98%', label: 'Soddisfazione utenti' },
            { value: '50K+', label: 'Utenti attivi' },
            { value: '24/7', label: 'Supporto disponibile' },
            { value: '100%', label: 'Dati protetti' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-accent-800 font-heading">
                {stat.value}
              </div>
              <div className="mt-1 text-xs text-foreground-600 font-body">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={onCategoryClick}
            className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap font-label"
          >
            Scopri come funziona
            <i className="ri-arrow-down-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}